import URLS from '@/server/urls';
import { DELETE } from '@/server/http';
import { base64encode } from '@/utils';

export default async ({
    url,
}, options = { showError: true }) => {
    const urlBase64 = base64encode(url);
    const [ content, error, status ] = await DELETE(`${URLS.common.delFileByNamePrefix}${urlBase64}`, {}, options);
    if (error) return { error, status };
    return content || {};
};
